/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const CrashTypeCategory = {
    Unknown: 'Unknown',
    RearEnd: 'RearEnd',
    HeadOn: 'HeadOn',
    Sideswipe: 'Sideswipe',
    RightAngle: 'RightAngle',
    TurningMovement: 'TurningMovement',
    HitPedestrian: 'HitPedestrian',
    HitCyclist: 'HitCyclist',
    HitObject: 'HitObject',
    Rollover: 'Rollover',
    HitAnimal: 'HitAnimal',
    Other: 'Other'
};
export function CrashTypeCategoryFromJSON(json) {
    return CrashTypeCategoryFromJSONTyped(json, false);
}
export function CrashTypeCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CrashTypeCategoryToJSON(value) {
    return value;
}
